var _rect, _path, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.667,
    height: 21.333,
    x: 26.667,
    y: 2.667,
    stroke: "#3461FD",
    strokeWidth: 1.5,
    rx: 5.333,
    transform: "rotate(90 26.667 2.667)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3461FD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21.454 20c-1.616-1.39-3.476-2.182-5.455-2.182-1.978 0-3.838.792-5.454 2.182"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3.273,
    stroke: "#3461FD",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "matrix(1 0 0 -1 16 11.273)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 25.333,
    r: 1.333,
    fill: "#3461FD",
    transform: "rotate(90 16 25.333)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfie);
export default __webpack_public_path__ + "static/media/selfie.3e373f25759ddca97e81e2c9b6c49a74.svg";
export { ForwardRef as ReactComponent };